
export function isGlobalLiverWebsite() {
    const host = window.location.hostname.toLowerCase();

    return host && (host.includes('globalliver') || host.includes('gli.nutristyle.com'));
}